import * as React from 'react';
import { useState } from 'react';
import { ROLES } from '../../constants';
import { useTranslation } from 'react-i18next';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import { getTaskNotifications, markNotificationAsRead, getClientPermissions } from '../../service/weexpertService';
import { formatDistanceToNow } from 'date-fns';
import AppBarForLogin from '../app-bar-for-main-login-pages/AppBarForLogin';
import logo from '../../assets/img/barLogo.png';
import arrowLeft from '../../assets/img/arrow-left.png';
import { CubeIcon, FileTextIcon, PersonIcon, BackpackIcon, LaptopIcon, AvatarIcon, ReaderIcon, ClipboardIcon, PaperPlaneIcon } from '@radix-ui/react-icons';
import { Link, useNavigate } from 'react-router-dom';
import VideoPopup from '../ui/dialogWithVideo';
import "../../i18.js";
import { useEffect, useRef } from 'react';
import { FileStackIcon, MessageSquare, PalmtreeIcon, CheckSquare, Bell, X, Loader2, CreditCard, BookOpen, HelpCircle } from 'lucide-react';
import AlertBanner from '../ui/alert-banner';
import { Badge } from '../ui/badge';
import { toast } from '../ui/use-toast';

const SuperAdmin = (t) => {
  return [
    {
      nav: t("navigation:main"),
      link: '/',
      img: <CubeIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:invoices"),
      link: '/admin/invoices/sales',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:users"),
      link: '/admin/administration',
      img: <AvatarIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:clients"),
      link: '/admin/clients',
      img: <BackpackIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:counterparties"),
      link: '/admin/contractors',
      img: <PersonIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:candidates"),
      link: 'candidates',
      img: <LaptopIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:vacation"),
      link: 'admin/user/client-shared-pool',
      img: <PalmtreeIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:contracts"),
      link: 'contracts',
      img: <FileStackIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:one_time_contract"),
      link: '/contracts/one-time',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:bills"),
      link: 'bills',
      img: <ReaderIcon className='w-5 h-5' />
    },
    {
      nav: t('navigation:specifications'),
      link: '/specifications',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t('reports:report_title'),
      link: '/reports',
      img: <ClipboardIcon className='w-5 h-5' />
    },
    {
      nav: t('navigation:tasks'),
      link: '/admin/tasks',
      img: <CheckSquare className='w-5 h-5' />
    },
    {
      nav: t('navigation:notifications'),
      link: '#notifications',
      img: <Bell className='w-5 h-5' />,
      isNotifications: true
    },
  ]
}

const HeadOfDepartmentOptions = (t) => {
  return [
    {
      nav: t("navigation:main"),
      link: '/',
      img: <CubeIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:invoices"),
      link: '/admin/invoices/sales',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:users"),
      link: '/admin/administration',
      img: <AvatarIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:clients"),
      link: '/admin/clients',
      img: <BackpackIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:counterparties"),
      link: '/admin/contractors',
      img: <PersonIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:candidates"),
      link: 'candidates',
      img: <LaptopIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:contracts"),
      link: 'contracts',
      img: <FileStackIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:one_time_contract"),
      link: '/contracts/one-time',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:bills"),
      link: 'bills',
      img: <ReaderIcon className='w-5 h-5' />
    },
    {
      nav: t('navigation:tasks'),
      link: '/admin/tasks',
      img: <CheckSquare className='w-5 h-5' />
    },
    {
      nav: t('navigation:notifications'),
      link: '#notifications',
      img: <Bell className='w-5 h-5' />,
      isNotifications: true
    }
  ]
}

const AssistantOptions = (t) => {
  return [
    {
      nav: t("navigation:main"),
      link: '/',
      img: <CubeIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:invoices"),
      link: '/admin/invoices/sales',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:clients"),
      link: '/admin/clients',
      img: <BackpackIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:counterparties"),
      link: '/admin/contractors',
      img: <PersonIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:contracts"),
      link: 'contracts',
      img: <FileStackIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:one_time_contract"),
      link: '/contracts/one-time',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:bills"),
      link: 'bills',
      img: <ReaderIcon className='w-5 h-5' />
    },
    {
      nav: t('navigation:specifications'),
      link: '/specifications',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t('reports:report_title'),
      link: '/reports',
      img: <ClipboardIcon className='w-5 h-5' />
    },
    {
      nav: t('navigation:tasks'),
      link: '/admin/tasks',
      img: <CheckSquare className='w-5 h-5' />
    },
    {
      nav: t('navigation:notifications'),
      link: '#notifications',
      img: <Bell className='w-5 h-5' />,
      isNotifications: true
    },
  ]
}

const ClientOptions = (t) => {
  return [
    {
      nav: t("navigation:main"),
      link: '/',
      img: <CubeIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:invoices"),
      link: '/admin/invoices/sales',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:counterparties"),
      link: '/admin/contractors',
      img: <PersonIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:contracts"),
      link: 'contracts',
      img: <FileStackIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:one_time_contract"),
      link: '/contracts/one-time',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:bills"),
      link: 'bills',
      img: <ReaderIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:bank_operations"),
      link: '/client-balance',
      img: <CreditCard className='w-5 h-5' />
    },
    {
      nav: t('navigation:specifications'),
      link: '/specifications',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:my_documents"),
      link: '/account?tab=documents',
      img: <FileTextIcon className='w-5 h-5' />
    },
    {
      nav: t("navigation:getting_started"),
      link: '/more-info',
      img: <BookOpen className='w-5 h-5' />
    },
    {
      nav: t("navigation:help_center"),
      link: '/help-info',
      img: <HelpCircle className='w-5 h-5' />
    },
    {
      nav: 'Telegram bot',
      link: '/telegram-bot/',
      img: <MessageSquare className='w-5 h-5' />
    }
  ]
}

const getOptionsForRole = ({role, features, permissions}, t) => {
  switch (role) {
    case ROLES.SUPER_ADMIN:
      return SuperAdmin(t);
    case ROLES.ADMIN:
      return SuperAdmin(t);
    case ROLES.CLIENT:
      if (features && features.includes("FEE_PAYMENT")) {
        // If client has platform access, show all navigation items
        if (permissions && permissions.canClientAccessPlatform) {
          //special access
          const allowedList = ['/', '/account?tab=documents', '/contracts/one-time', '/help-info', '/more-info'];
          return ClientOptions(t).filter(e => allowedList.includes(e.link));
        } else {
          // If client doesn't have platform access, hide business-related items
          const allowedList = ['/', '/account?tab=documents', '/help-info', '/more-info'];
          return ClientOptions(t).filter(e => allowedList.includes(e.link));
        }
      }
      const forbiddenList = ['/telegram-bot/', '/account?tab=documents', 'client-balance']
      return ClientOptions(t).filter(e => forbiddenList.includes(e.link) === false);
    case ROLES.ASSISTANT:
      return AssistantOptions(t);
    case ROLES.HEAD_OF_DEPARTMENT:
      return HeadOfDepartmentOptions(t);
    default:
      return []
  }
}

export default function PersistentDrawerLeft(props) {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language)
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userData, showBar } = props;
  const [open, setOpen] = useState(() => {
    const storedValue = localStorage.getItem("openSideBar");
    return storedValue !== null ? storedValue === 'true' : true;
  });
  const [activeItem, setActiveItem] = useState('');

  // Fetch client permissions for CLIENT users with FEE_PAYMENT feature
  const shouldFetchPermissions = userData &&
    userData.roles === ROLES.CLIENT &&
    userData.features &&
    userData.features.includes("FEE_PAYMENT");

  const { data: permissionsData } = useQuery({
    queryKey: ['clientPermissions'],
    queryFn: getClientPermissions,
    enabled: shouldFetchPermissions,
    retry: false,
    refetchOnWindowFocus: false
  });

  const permissions = permissionsData?.data;
  const options = userData ? getOptionsForRole({ role: userData.roles, id: userData.id, features: userData.features, permissions}, t) : [];
  const [videoUrl, setVideoUrl] = useState('');
  const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);
  const notificationDropdownRef = useRef(null);
  const notificationTriggerRef = useRef(null);
  const queryClient = useQueryClient();

  // Fetch notifications for non-client users
  const { data: notificationsData } = useQuery(
    'taskNotifications',
    getTaskNotifications,
    {
      enabled: userData && userData.roles !== 'CLIENT',
      refetchInterval: 30000, // Refetch every 30 seconds
    }
  );

  // Handle different response structures defensively
  let notifications = [];
  if (notificationsData?.data) {
    if (Array.isArray(notificationsData.data)) {
      notifications = notificationsData.data;
    } else if (Array.isArray(notificationsData.data.notifications)) {
      notifications = notificationsData.data.notifications;
    }
  }

  const unreadCount = Array.isArray(notifications) ? notifications.filter(n => !n.isRead).length : 0;

  // Mark notification as read mutation
  const markAsReadMutation = useMutation(markNotificationAsRead, {
    onSuccess: () => {
      queryClient.invalidateQueries('taskNotifications');
      toast({
        title: t("tasks:notification_marked_read"),
        description: t("tasks:notification_marked_read_desc"),
        variant: "default"
      });
    },
    onError: (error) => {
      toast({
        title: t("tasks:error"),
        description: t("tasks:notification_mark_read_failed"),
        variant: "destructive"
      });
    }
  });

  const handleMarkAsRead = (notificationId, e) => {
    e.stopPropagation();
    markAsReadMutation.mutate(notificationId);
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="relative inline-block group">
        {children}
        <div className="hidden group-hover:block absolute bg-gray-800 text-white left-14 top-0 text-xs py-1 px-2 rounded-md shadow-md z-10 whitespace-nowrap">
          {text}
          <svg className="absolute text-gray-800 h-2 w-full top-full" x="0px" y="0px" viewBox="0 0 255 255">
            <polygon className="fill-current" points="0,0 127.5,1.5 255,0" />
          </svg>
        </div>

      </div>
    );
  };

  const handleItemClick = (link) => {
    setActiveItem(link);
  };

  useEffect(() => {
    setLang(i18n.language);
    setVideoUrl(
      i18n.language === 'ru'
        ? 'https://www.youtube.com/embed/tTTA8Fs6waU'
        : 'https://www.youtube.com/embed/tTTA8Fs6waU'
    );
  }, [i18n.language]);

  const changeSideBarWidth = () => {
    setOpen(prevOpen => {
      const newOpen = !prevOpen;
      localStorage.setItem("openSideBar", newOpen);
      return newOpen;
    });
  }

  useEffect(() => {
    const storedValue = localStorage.getItem("openSideBar");
    if (storedValue === null) {
      localStorage.setItem("openSideBar", true);
    }
    setOpen(storedValue !== null ? storedValue === 'true' : true);
  }, []);

  // Close notification dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationDropdownRef.current &&
        !notificationDropdownRef.current.contains(event.target) &&
        notificationTriggerRef.current &&
        !notificationTriggerRef.current.contains(event.target)) {
        setNotificationDropdownOpen(false);
      }
    };

    if (notificationDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [notificationDropdownOpen]);

  return (
    <div className='relative w-full h-full p-0 m-0 color-black'>
      <AppBarForLogin
        isLogined={props.userData}
        userData={props.userData}
        options={options}
      />
      {userData && (
        <div className={`fixed left-0 top-0 z-40 transition-width ${open ? 'w-52' : 'w-20'} p-0 m-0 h-screen bg-white border-r-[1px] mr-2 hidden md:block`}>
          <div className={`absolute top-5 left-5 cursor-pointer flex justify-between items-center ${open ? 'pl-3' : ''} w-5/6 hidden md:flex`}
            onClick={() => changeSideBarWidth(open)}>
            <div className='flex justify-between items-center'>
              <div className='flex justify-center items-center'>
                <img className={`${!open ? "h-[18px]" : ""}`} src={logo} alt="logo" />
              </div>
              {!open && (
                <div className='pl-[4px]'>
                  <img className='rotate-180' src={arrowLeft} alt="arrow" />
                </div>
              )}
            </div>
            <div className="flex items-center space-x-2">
              {open && <img src={arrowLeft} alt="arrow" />}
            </div>
          </div>
          <div className='pt-28 flex flex-col justify-center items-start'>
            {options.map((item, index) => {
              if (item.isNotifications) {
                return (
                  <div
                    key={index}
                    ref={notificationTriggerRef}
                    className={`p-2 w-5/6 mx-auto mb-2 rounded-md cursor-pointer hover:text-blueLink relative ${notificationDropdownOpen ? 'bg-blueLightAccent text-blueLink' : ''}`}
                    data-role={item.nav}
                    onClick={() => setNotificationDropdownOpen(!notificationDropdownOpen)}
                  >
                    <div className={`flex ${open ? 'justify-start' : 'justify-center'} items-center relative`}>
                      {open ? (
                        <div className="relative">
                          {item.img}
                          {unreadCount > 0 && (
                            <Badge
                              variant="destructive"
                              className="absolute -top-2 -right-2 h-4 w-4 flex items-center justify-center p-0 text-xs"
                            >
                              {unreadCount > 9 ? '9+' : unreadCount}
                            </Badge>
                          )}
                        </div>
                      ) : (
                        <Tooltip text={`${item.nav}${unreadCount > 0 ? ` (${unreadCount})` : ''}`}>
                          <div className="relative">
                            {item.img}
                            {unreadCount > 0 && (
                              <Badge
                                variant="destructive"
                                className="absolute -top-2 -right-2 h-4 w-4 flex items-center justify-center p-0 text-xs"
                              >
                                {unreadCount > 9 ? '9+' : unreadCount}
                              </Badge>
                            )}
                          </div>
                        </Tooltip>
                      )}
                      <div className={`text-[14px] ${open ? '' : 'hidden'} pl-2 `}>{item.nav}</div>
                    </div>
                  </div>
                );
              }

              return (
                <Link to={`${item.link}`} className={`p-2 w-5/6 mx-auto mb-2 rounded-md cursor-pointer hover:text-blueLink ${activeItem === item.link ? 'bg-blueLightAccent text-blueLink' : ''}`}
                  key={index}
                  data-role={item.nav}
                  onClick={() => handleItemClick(item.link)}
                >
                  <div className={`flex ${open ? 'justify-start' : 'justify-center'} items-center`}>
                    {open ? (
                      <div>{item.img}</div>
                    ) : (
                      <Tooltip text={item.nav}>
                        <div>{item.img}</div>
                      </Tooltip>
                    )}
                    <div className={`text-[14px] ${open ? '' : 'hidden'} pl-2 `}>{item.nav}</div>
                  </div>
                </Link>
              );
            })}

            {/* Notification dropdown content - positioned to the right */}
            {notificationDropdownOpen && (
              <div
                ref={notificationDropdownRef}
                className={`absolute ${open ? 'left-full' : 'left-20'} top-0 ml-2 w-80 bg-white border rounded-md shadow-xl z-50 max-h-96 overflow-hidden`}
              >
                {/* Arrow pointer */}
                <div className="absolute left-0 top-6 transform -translate-x-1 w-2 h-2 bg-white border-l border-t rotate-45"></div>

                {/* Header */}
                <div className="px-4 py-3 border-b bg-gray-50">
                  <h3 className="text-sm font-medium text-gray-900">{t('tasks:task_notifications')}</h3>
                  {unreadCount > 0 && (
                    <p className="text-xs text-gray-500 mt-1">{unreadCount} {t('tasks:unread')} {t('tasks:task_notifications').toLowerCase()}</p>
                  )}
                </div>

                {/* Notifications list */}
                <div className="max-h-80 overflow-y-auto">
                  {notifications.length === 0 ? (
                    <div className="p-6 text-center text-gray-500 text-sm">
                      <Bell className="w-8 h-8 mx-auto mb-2 text-gray-300" />
                      {t('tasks:no_notifications')}
                    </div>
                  ) : (
                    notifications.slice(0, 8).map((notification) => (
                      <div
                        key={notification.id}
                        className={`p-4 border-b hover:bg-gray-50 cursor-pointer transition-colors ${!notification.isRead ? 'bg-blue-50 border-l-4 border-l-blue-500' : ''
                          }`}
                        onClick={() => {
                          const taskId = notification.task?.id;
                          if (taskId) {
                            window.location.href = `/admin/task/details/${taskId}`;
                          }
                          setNotificationDropdownOpen(false);
                        }}
                      >
                        <div className="flex items-start space-x-3">
                          <div className="flex-shrink-0 mt-1">
                            {notification.type === 'ASSIGNED' && <Bell className="w-4 h-4 text-blue-500" />}
                            {notification.type === 'COMPLETED' && <CheckSquare className="w-4 h-4 text-green-500" />}
                            {notification.type === 'REMINDER' && <Bell className="w-4 h-4 text-yellow-500" />}
                            {notification.type === 'OVERDUE' && <Bell className="w-4 h-4 text-red-500" />}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="text-sm font-medium text-gray-900 truncate">
                              {notification.task?.title || t('tasks:task_notification_fallback')}
                            </div>
                            <div className="text-xs text-gray-600 mt-1">
                              {notification.type === 'ASSIGNED' && t('tasks:new_task_assigned')}
                              {notification.type === 'COMPLETED' && t('tasks:task_completed')}
                              {notification.type === 'REMINDER' && t('tasks:task_reminder')}
                              {notification.type === 'OVERDUE' && t('tasks:task_overdue')}
                            </div>
                            <div className="text-xs text-gray-500 mt-2 space-y-1">
                              {notification.task?.createdAt && (
                                <div>{t('tasks:task_created_prefix')} {formatDistanceToNow(new Date(notification.task.createdAt), { addSuffix: true })}</div>
                              )}
                              <div>{t('tasks:notified_prefix')} {formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true })}</div>
                            </div>
                          </div>
                          <div className="flex-shrink-0 flex items-center space-x-2">
                            {!notification.isRead && (
                              <button
                                onClick={(e) => handleMarkAsRead(notification.id, e)}
                                disabled={markAsReadMutation.isLoading}
                                className="p-1 rounded-full hover:bg-gray-200 transition-colors disabled:opacity-50"
                                title={t('tasks:mark_as_read_tooltip')}
                              >
                                {markAsReadMutation.isLoading && markAsReadMutation.variables === notification.id ? (
                                  <Loader2 className="w-3 h-3 animate-spin text-gray-600" />
                                ) : (
                                  <X className="w-3 h-3 text-gray-600 hover:text-gray-800" />
                                )}
                              </button>
                            )}
                            {!notification.isRead && (
                              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                {/* Footer */}
                {notifications.length > 0 && (
                  <div className="border-t bg-gray-50">
                    <button
                      className="w-full p-3 text-center text-blue-600 hover:text-blue-700 hover:bg-gray-100 transition-colors text-sm font-medium"
                      onClick={() => {
                        window.location.href = '/admin/tasks';
                        setNotificationDropdownOpen(false);
                      }}
                    >
                      {t('tasks:view_all_tasks_button')}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      <div className={userData ? `transition-margin-left mt-12 ${open ? 'ml-0 md:ml-52' : 'ml-0 md:ml-20'}` : 'w-full m-0 p-0'}>
        {userData ? userData.roles === 'CLIENT' && (
          <AlertBanner
            text={t('banner_text')} />
        ) : null}
        {props.children}
        {userData ? userData.roles === 'CLIENT' && (
          <VideoPopup
            videoUrl={videoUrl}
          />
        ) : null}
      </div>
    </div>
  );
}
